import {
  Description as HeadlessDescription,
  type DescriptionProps as HeadlessDescriptionProps,
} from "@headlessui/react";
import { classNames } from "../../utils/classNames";

export function Description({
  className,
  disabled,
  ...props
}: { className?: string; disabled?: boolean } & HeadlessDescriptionProps) {
  return (
    <HeadlessDescription
      {...props}
      data-slot="description"
      className={classNames(
        "text-sm/5 text-tertiary data-[disabled]:opacity-50",
        className,
      )}
    />
  );
}
